import { render } from "./hand-index.vue?vue&type=template&id=0614e044"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/hand-index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0614e044"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0614e044', __exports__)) {
    api.reload('0614e044', __exports__)
  }
  
  module.hot.accept("./hand-index.vue?vue&type=template&id=0614e044", () => {
    api.rerender('0614e044', render)
  })

}


export default __exports__